import React from 'react'

function About() {
  return (
    <div>
      Aboyut
    </div>
  )
}

export default About
